import React from 'react';
import { translate } from '../../Services/translation';

interface IconTextProps {
  translationKey?: string;
  text?: string;
}

const IconText = ({ translationKey, text }: IconTextProps) => {
  return (
    <span className="text-white text-[1.2rem]">
      {translationKey ? translate(translationKey) : text}
    </span>
  );
};

export default IconText;
